export default __webpack_public_path__ + "static/media/rideAlong.22b9d2de.jpg";